"use client";

import { Box, Card, CardContent, CardHeader, Typography } from "@repo/ui";
import Link from "next/link";
import DynamicIcon from "@/components/Icon";
import { useParams } from "next/navigation";

interface CategoryCardProps {
  isContentType?: boolean;
  className?: string;
  title: string;
  slug?: string;
  totalCourses?: string | number;
  courses?: { name: string }[];
  description?: string;
  icon?: any;
}

const CategoryCard = ({
  isContentType = false,
  className,
  courses = [],
  title,
  slug,
  totalCourses,
  description,
  icon: Icon,
}: CategoryCardProps) => {
  const { country } = useParams<{ country: string }>();

  return (
    <Card
      className={`tracking-wide h-full ${className}`}
      outlined
      render={
        slug ? (
          <Link
            href={`${country ? `/${country}/topic/${slug}` : `/topic/${slug}`}`}
          />
        ) : (
          <div />
        )
      }
    >
      {Boolean(Icon) && (
        <CardHeader className="!pb-0">
          <Box className="bg-primary-light/20 text-primary-main  inline-flex p-3 rounded-full">
            {typeof Icon === "string" ? <DynamicIcon name={Icon} /> : <Icon />}
          </Box>
        </CardHeader>
      )}
      {!isContentType && (
        <CardContent className="flex flex-col h-full">
          <Typography variant="h4" render={<div />} gutterBottom>
            {title}
          </Typography>
          <Typography
            variant="body1"
            className=" text-gray-500 tracking-wide  !text-sm"
          >
            {totalCourses} courses
          </Typography>
          {Boolean(courses?.length) && (
            <>
              <Box className="ml-1 gray-text mt-2 flex-1">
                {courses.slice(0, 3).map((course, index) => (
                  <Typography
                    variant="body1"
                    className="!leading-6 truncate mb-1"
                    key={`list-of-top-cat-courses-${index}`}
                  >
                    {index + 1}. {course.name}
                  </Typography>
                ))}
              </Box>
              {courses?.length > 3 && (
                <Typography
                  variant="body1"
                  color="primary"
                  className="text-primary-main !leading-6 !tracking-wide font-semi-bold"
                >
                  +{courses?.length - 3} More
                </Typography>
              )}
            </>
          )}
        </CardContent>
      )}
      {isContentType && (
        <CardContent>
          <Typography
            variant="h5"
            render={<div />}
            className="font-semi-bold text-base tracking-wide"
          >
            {title}
          </Typography>
          <Typography variant="body1" className="mt-5 gray-text tracking-wide">
            {description}
          </Typography>
        </CardContent>
      )}
    </Card>
  );
};

export default CategoryCard;
